import parseAccounts from '@/lib/data/parseAccounts.mjs';
import request from '@/lib/request.mjs';

export default function (forceRefresh = false) {
  return request('accounts', { forceRefresh }).then(parseAccounts);
}
